import { render, staticRenderFns } from "./PortDetailPage.vue?vue&type=template&id=360dc2b8&scoped=true&"
import script from "./PortDetailPage.vue?vue&type=script&lang=js&"
export * from "./PortDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360dc2b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360dc2b8')) {
      api.createRecord('360dc2b8', component.options)
    } else {
      api.reload('360dc2b8', component.options)
    }
    module.hot.accept("./PortDetailPage.vue?vue&type=template&id=360dc2b8&scoped=true&", function () {
      api.rerender('360dc2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/PortDetailPage.vue"
export default component.exports